<template>
  
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})" style="cursor: pointer;">首页</a-breadcrumb-item>
      <a-breadcrumb-item>{{title}}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <router-view/>
  </div>
  </div>
</template>
<script>
export default {
  name: 'investor',
  props: {
  },
  mounted() {
    this.title = this.$route.query.type
  },
  data() {
    return {
      title:''
    }
  },
	methods: {
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
			this.$router.push('/')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
</style>